import { Box } from "@mui/material"

export const Arrow = ({ color, width = 24, height = 24, inversed = false }) => {
    return (
        <Box
            component="svg"
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 32.697 25.218"
            sx={{
                transform: "rotate(" + (inversed ? "180deg" : "0") + ")",
                color: color || "#a18168",
            }}
            className="transition-colors"
        >
            <line
                x1=".125"
                y1="12.609"
                x2="32.572"
                y2="12.609"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
            />
            <line
                x1="32.572"
                y1="12.609"
                x2="20.088"
                y2=".125"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
            />
            <line
                x1="32.572"
                y1="12.609"
                x2="20.088"
                y2="25.093"
                stroke={"currentColor"}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1px"
            />
        </Box>
    )
}